import { render, staticRenderFns } from "./PriorityTypeForm.vue?vue&type=template&id=037c565d&"
import script from "./PriorityTypeForm.vue?vue&type=script&lang=js&"
export * from "./PriorityTypeForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports